import {validatePolish} from "validate-polish";

export function nipValidator(elem: any, args: any, val: any): boolean {
	return validatePolish.nip(val);
}
